import React, { useState, useEffect } from "react";
import Footer from "../homePage/components/footer/Footer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MapPinCheck } from "lucide-react";
import { PhoneCall } from "lucide-react";
import { PrinterCheck } from "lucide-react";
import { MailCheck } from "lucide-react";
import {
    Select,
    FormControl,
    FormLabel,
    Box,
    chakra,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getMakeDataAPi, getModelDataAPi, getProductDataAPi, getYearDataAPi } from "../../../redux/reduxApi/website/MakeYearModel";
import { createGetInTouch } from "../../../redux/api/website/contactUsApis";
import { toast } from "react-toastify";

export default function ContactUs() {
    const [selectedDate, setSelectedDate] = useState(null);
    const [minDate, setMinDate] = useState('');
    const { getYearData: yearOptions } = useSelector((state) => state.MakeYearModel);
    console.log("yearOptions", yearOptions);
    const [loading, setLoading] = useState("")
    const [makeOptions, setMakeOptions] = useState([]);
    const [modelOptions, setModelOptions] = useState([])

    // Form state
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        vehicleYear: '',
        vehicleMake: '',
        vehicleModel: '',
        partNumber: '',
        message: ''
    });
    const dispatch = useDispatch();
    useEffect(()=>{
        dispatch(getYearDataAPi())
    },[])

    useEffect(() => {
        window.scrollTo(0, 0);
        const today = new Date().toISOString().split('T')[0];
        setMinDate(today);
    }, []);

    const handleYearChange = async (event) => {
        const year = event.target.value;
        setFormData((prev) => ({ ...prev, vehicleYear: year }))

        try {
            setLoading("Make");
            const res = await getMakeDataAPi(year);
            // console.log("make res", res);
            if (res) {
                setMakeOptions(res);
            }
        } catch (error) {
            console.error("Error in fetching make list:", error);
        } finally {
            setLoading("");
        }
    };

    const handleMakeChange = async (event) => {
        const selectedMake = event.target.value;
        setFormData((prev) => ({ ...prev, vehicleMake: selectedMake }))

        try {
            setLoading("Model");
            const res = await getModelDataAPi({ selectedYear: formData.vehicleYear, selectedMake });
            if (res) {
                setModelOptions(res);
            }
        } catch (error) {
            console.error("Error in fetching model list:", error);
        } finally {
            setLoading("");
        }
    };

    const handleModelChange = async (event) => {
        const selectedModel = event.target.value;
        setFormData((prev) => ({ ...prev, vehicleModel: selectedModel }))

        try {
            setLoading("Part");
            const res = await getProductDataAPi({
                selectedYear: formData.vehicleYear,
                selectedMake: formData.vehicleMake,
                selectedModel: selectedModel
            });
            if (res) {
                // setpartTypeOptions(res);
                // const uniqueByValueAndLabel = Array.from(
                //     new Map(res.map(item => [`${item.value}|||${item.label}`, item])).values()
                // ).sort((a, b) => a.label.localeCompare(b.label));
                // setUniquepPartTypeOptions(uniqueByValueAndLabel || []);
            }
        } catch (error) {
            console.error("Error in fetching Part list:", error);
        } finally {
            setLoading("");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSelectChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        // alert(`Thank you for your inquiry! We'll get back to you soon.`);
        setLoading('submit');
        createGetInTouch(formData).then((res)=>{
            if(res?.data?.success){
                toast.success("Thank you for your inquiry! We'll get back to you soon.")
            }else{
                toast.warn(res?.data?.message)
            }
        }).catch((err)=>{
            toast.error(err?.response?.data?.error || "Sorry for the inconvenience, Please try later")
        }).finally(()=>{
            setLoading("")
        })
    };

 
 

    return (
        <div className="mt-[75px]">
            <div>
                <iframe
                    src="https://www.google.com/maps/d/embed?mid=1KSvE_gLA3hQBNNeleg6LeN2Sl9a9y84&ehbc=2E312F&ll="
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    allowFullScreen
                ></iframe>
            </div>
            <div class="container py-[50px]">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:mx-[5.4%] gap-2 items-center">
                    <div className="mb-8 w-full">
                        <h1 class="text-3xl text-orange-500 font-bold mb-2">
                            GET IN TOUCH
                        </h1>
                        <h1 class="text-xl font-bold mb-2">
                            Contact Us To Get Better Information
                        </h1>
                        <p class="text-black-600 mb-6">
                            Our experts are ready to assist you with the right automotive
                            parts, service information, and support.
                        </p>
                        <div class="mb-4">
                            <h1 class="font-bold mb-2 text-xl">Let's Talk</h1>
                            <p class="flex items-center mb-3">
                                <MapPinCheck className="mr-2" /> 10509 135a St, Surrey, BC V3T 4C9
                            </p>
                            <p class="flex items-center mb-3">
                                <MapPinCheck className="mr-2" />
                                2098 Commercial Dr, Vancouver, BC V5N 4B2
                            </p>
                            <p class="flex items-center mb-3">
                                <MapPinCheck className="mr-2" />
                                2910 St Johns St, Port Moody, BC V3H 2C3
                            </p>
                            <p class="flex items-center mb-3">
                                <PhoneCall className="mr-2" />
                                <a
                                    href="tel:+16045815464"
                                    className="hover:text-yellow-400 transition"
                                >
                                    Surrey 604-581-5464
                                </a>
                            </p>
                            <p class="flex items-center mb-3">
                                <PhoneCall className="mr-2" />
                                <a
                                    href="tel:+16042519060"
                                    className="hover:text-yellow-400 transition"
                                >
                                    Vancouver 604-251-9060
                                </a>
                            </p>
                            <p class="flex items-center mb-3">
                                <PhoneCall className="mr-2" />
                                <a
                                    href="tel:+16044612999"
                                    className="hover:text-yellow-400 transition"
                                >
                                    Port Moody 604-461-2999
                                </a>
                            </p>
                            <p class="flex items-center mb-3">
                                <MailCheck className="mr-2" />
                                <a
                                    href="mailto:info@vapautoparts.ca"
                                    onClick={(e) => {
                                        setTimeout(() => {
                                            window.open(
                                                "https://mail.google.com/mail/?view=cm&to=info@vapautoparts.ca",
                                                "_blank",
                                                "noopener,noreferrer"
                                            );
                                        }, 500);
                                    }}
                                    className="hover:text-yellow-400 transition cursor-pointer"
                                >
                                    info@vapautoparts.ca
                                </a>
                            </p>
                        </div>
                    </div>

                    <div class="border-2 border-orange-500 p-3 rounded-lg">
                        <h2 class="text-3xl font-bold mb-2 text-center">Get in touch</h2>

                        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {/* Name - Full width */}
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    Name<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                    className="mt-1 block w-full border border-black p-2 rounded"
                                    placeholder="Your full name"
                                />
                            </div>

                            {/* Email */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Your Email<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                    className="mt-1 block w-full border border-black p-2 rounded"
                                    placeholder="your@email.com"
                                />
                            </div>

                            {/* Phone Number */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Your Phone Number<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    required
                                    className="mt-1 block w-full border border-black p-2 rounded"
                                    placeholder="(604) 555-1234"
                                />
                            </div>

                            {/* Vehicle Year - Chakra UI */}
                            <div>
                                <FormControl>
                                    <FormLabel fontSize="sm" mb={1} color="gray.700">
                                        Vehicle Year<span style={{ color: 'red' }}>*</span>
                                    </FormLabel>
                                    <Select
                                        name="vehicleYear"
                                        value={formData.vehicleYear}
                                        // onChange={(e) => handleSelectChange('vehicleYear', e.target.value)}
                                        onChange={handleYearChange}
                                        required
                                        bg="white"
                                        border="1px solid"
                                        borderColor="black"
                                        borderRadius="md"
                                        _hover={{ borderColor: "black" }}
                                        _focus={{ borderColor: "orange.500", boxShadow: "none" }}
                                        height="40px"
                                    >
                                        <option value="">Choose Year</option>
                                        {yearOptions.map(year => (
                                            <option key={year.value} value={year.value}>{year.label}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Vehicle Make - Chakra UI */}
                            <div>
                                <FormControl>
                                    <FormLabel fontSize="sm" mb={1} color="gray.700">
                                        Vehicle Make<span style={{ color: 'red' }}>*</span>
                                    </FormLabel>
                                    <Select
                                        name="vehicleMake"
                                        value={formData.vehicleMake}
                                        // onChange={(e) => handleSelectChange('vehicleMake', e.target.value)}
                                        onChange={handleMakeChange}
                                        required
                                        bg="white"
                                        border="1px solid"
                                        borderColor="black"
                                        borderRadius="md"
                                        _hover={{ borderColor: "black" }}
                                        _focus={{ borderColor: "orange.500", boxShadow: "none" }}
                                        height="40px"
                                    >
                                        <option value="">
                                            {loading == "Make" ? "Loading..." : "Make"}
                                        </option>
                                        <option value="">Choose Make</option>
                                        {(makeOptions || [])?.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Vehicle Model - Chakra UI */}
                            <div>
                                <FormControl>
                                    <FormLabel fontSize="sm" mb={1} color="gray.700">
                                        Vehicle Model<span style={{ color: 'red' }}>*</span>
                                    </FormLabel>
                                    <Select
                                        name="vehicleModel"
                                        value={formData.vehicleModel}
                                        // onChange={(e) => handleSelectChange('vehicleModel', e.target.value)}
                                        onChange={handleModelChange}
                                        required
                                        bg="white"
                                        border="1px solid"
                                        borderColor="black"
                                        borderRadius="md"
                                        _hover={{ borderColor: "black" }}
                                        _focus={{ borderColor: "orange.500", boxShadow: "none" }}
                                        height="40px"
                                    >
                                        <option value="">
                                            {loading == "Model" ? "Loading..." : "Model"}
                                        </option>
                                        {(modelOptions || [])?.map((option) => (
                                            <option key={option?.value} value={option?.value}>
                                                {option?.label}
                                            </option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Part Number */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700">
                                    Part Number
                                </label>
                                <input
                                    type="text"
                                    name="partNumber"
                                    value={formData.partNumber}
                                    onChange={handleInputChange}
                                    className="mt-1 block w-full border border-black p-2 rounded"
                                    placeholder="e.g., BR-12345, 12345-ABC"
                                />
                            </div>

                            {/* Message - Full width */}
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    Message<span className="text-red-500">*</span>
                                </label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                    rows="4"
                                    className="mt-1 block w-full border border-black p-2 rounded"
                                    placeholder="Please describe what part you're looking for or any specific questions..."
                                ></textarea>
                            </div>

                            {/* Submit Button */}
                            <div className="md:col-span-2">
                                <button
                                    type="submit"
                                    className="w-full bg-[#034C8C] text-white font-bold py-2 px-4 rounded hover:bg-[#023b6b] transition duration-200"
                                >
                                    {loading=="submit"? "Sending..." :"Send Message"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* <Footer /> */}
        </div>
    );
}